module.exports = __webpack_public_path__ + "static/media/mashkor512.b0dcbab8.png";